import { domain } from './domain'
import { api } from '../api'

export const getJackpots = domain.createEvent('try to get jackpots')
export const getJackpotsFx = domain.createEffect('get jackpots', {
  handler: api.fetchJackpots,
})
